export const ARTICLE_TERM_ID = "termConditions";
export const ARTICLE_RETURN_ID = "returnPolicy";
export const ARTICLE_SUPPORT_ID = "supportPolicy";
export const ARTICLE_PRIVACY_ID = "privacyPolicy";
